<template>
  <div class="header">
    <div class="left">
      <img src="../assets/images/logo@2x.png" alt />
    </div>
    <div class="nav">
      <router-link to="/WZSY" :class="routerName =='/WZSY' ? 'router-active': ''">网站首页</router-link>
      <router-link to="/DLJZ" :class="routerName =='/DLJZ' ? 'router-active': ''">代理记账</router-link>
      <ul class="register">
        <router-link to="/ZCZX" :class="routerName =='/ZCZX' ? 'router-active': ''">注册注销</router-link>
        <ul class="second">
          <li>
            <router-link to="/ZCZX/cancelled">注销公司</router-link>
          </li>
          <li>
            <router-link to="/ZCZX/register">注册公司</router-link>
          </li>
        </ul>
      </ul>
      <router-link to="/SJBG" :class="routerName =='/SJBG' ? 'router-active': ''">审计报告</router-link>
      <router-link to="/SSCH" :class="routerName =='/SSCH' ? 'router-active': ''" style="white-space: nowrap;">税收合规安排</router-link>
      <router-link to="/GXSB" :class="routerName =='/GXSB' ? 'router-active': ''">高新申报</router-link>
      <router-link to="/ZSZX" :class="routerName =='/ZSZX' ? 'router-active': ''">中税资讯</router-link>
      <router-link to="/GYWM" :class="routerName =='/GYWM' ? 'router-active': ''">关于我们</router-link>
    </div>
    <div class="right">
      <div>
        <img src="../assets/images/ic_home_phone.png" alt />
      </div>
      <div class="content">
        <h4>服务热线</h4>
        <span>市区: 0571-81022373 18258189820</span>
        <span>下沙: 0571-88149990 13093793611</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      router: false,
      routerName: ""
    };
  },
  created() {
    let path = this.$route.path;
    // console.log(this.$route);
    this.router = /\/ZCZX/.test(this.$route.path);
    this.routerName = this.$route.matched[0].path;
  },
  beforeRouteUpdate(to, from, next) {
    // console.log("路由");
    next();
  },
  watch: {
    $route(to, from) {
      let path = to.path;
      console.log(to);
      this.router = /\/ZCZX/.test(to.path);
      this.routerName = to.matched[0].path;
    }
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
a:hover {
  color: rgb(2, 121, 231);;
}
$header-text-color: #707070;
.router-active {
  font-size: 15px !important;
  font-weight: bold !important;
  color: rgb(2, 121, 231);
}
.header {
  width: 1040px;
  height: 60px;
  // padding-left: 16%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.left {
  width: 94px;
  height: 17px;
  img {
    width: 100%;
  }
}
.nav {
  width: 61%;
  margin-left: 30.4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .register {
    position: relative;
    flex: 1;
    text-align: center;
    margin: 0;
    .second {
      position: absolute;
      left: 0;
      right: 0;
      background: #ffffff;
      z-index: 10;
      display: none;
      margin: 0;
      li {
        list-style: none;
        text-align: center;
        background-color: rgb(250, 250, 250);
        font-size: 13px;
        border: 1px solid rgb(240, 240, 240);
        margin-bottom: -1px;
        padding: 5px 0;
      }
    }
    .second:hover {
      display: block;
    }
    .second li:hover {
      background: burlywood;
      a {
        color: #ffffff;
      }
    }
  }
  .register:hover {
    .second {
      display: block;
    }
  }
  // span {
  //   padding: 2rem 1.2rem;
  //   font-size: 1rem;
  //   color: $header-text-color;
  // }
}
.nav > a {
  flex: 1;
  text-align: center;
}

.right {
  width: 250px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  .content {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-size: 11px;
    span {
      color: $header-text-color;
    }
  }
}
.right img {
  width: 30px;
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue